<template>
	<div
		v-if="shouldShowTestSiteWarning && !dismissed"
		class="fixed bg-red-500 text-white text-center font-bold p-2 flex justify-between items-center z-50 w-full">
		<span class="grow">{{ $t("testSiteWarning") }}</span>
		<FormLink
			:slim="true"
			custom-class="max-sm:basis-1/6 !text-white font-bold"
			@click="dismissNotification"
			>{{ $t("dismiss") }}</FormLink
		>
	</div>
</template>

<script setup>
	const runtimeConfig = useRuntimeConfig()
	const shouldShowTestSiteWarning = runtimeConfig.public.SHOW_TEST_SITE_WARNING
	const siteTestWarningCookie = "UP_DISMISSED_TEST_SITE_WARNING"

	let dismissed = ref(false)

	const cookie = useCookie(siteTestWarningCookie, {
		maxAge: 60 * 60, // 1 hour
		path: "/", // Cookie available across the entire site
		secure: true, // Only sent over HTTPS
		httpOnly: false, // Accessible via JavaScript
		sameSite: "lax", // Prevent CSRF attacks
	})

	const dismissNotification = () => {
		dismissed.value = true
		cookie.value = siteTestWarningCookie
	}

	// Check if the cookie exists
	if (cookie.value === siteTestWarningCookie) {
		dismissed.value = true
	}
</script>

<style scoped></style>
